import { Box, Flex, } from "@chakra-ui/react";
import React from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
  return (
      <Flex
          position={"absolute"}
          boxShadow={"none"}
          bg={"none"}
          borderColor={"transparent"}
          filter={"none"}
          // backdropFilter={"blur(21px)"}
          borderWidth="1.5px"
          borderStyle="solid"
          transitionDelay="0s, 0s, 0s, 0s"
          transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
          transition-property="box-shadow, background-color, filter, border"
          transitionTimingFunction="linear, linear, linear, linear"
          alignItems={{ xl: "center" }}
          borderRadius="16px"
          display="flex"
          minH="75px"
          justifyContent={{ xl: "center" }}
          lineHeight="25.6px"
          mx="auto"
          mt={"0px"}
          pb="8px"
          right="30px"
          px={{ sm: "15px", md: "30px", }}
          ps={{ xl: "12px", }}
          pt="8px"
          top="18px"
          w={{ sm: "calc(100vw - 30px)", xl: "calc(100vw - 75px - 275px)" }}
      >
        <Flex w="100%" flexDirection={{ sm: "column", md: "row", }} alignItems={{ xl: "center" }} >
          <Box ms="auto" w={{ sm: "100%", md: "unset" }}>
            <AdminNavbarLinks
                logoText={props.logoText}
                secondary={props.secondary}
                fixed={props.fixed}
                initialValue={props.initialValue}
                onChange={props.onChange}
                debounce={props.debounce}
            />
          </Box>
        </Flex>
      </Flex>
  );
}
